import { useCallback, useEffect, useState } from 'react';
import { socialApi } from '@/api';
import type { SocialAccountResponse } from '@/types/social';
import { showApiError } from '@/utils/apiError';

export function useSocialAccounts() {
  const [accounts, setAccounts] = useState<SocialAccountResponse[]>([]);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const list = await socialApi.listAccounts();
      setAccounts(list);
    } catch (err) {
      showApiError(err, 'Failed to load social accounts');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void reload();
  }, [reload]);

  const connected = accounts.filter((a) => a.connected);
  const byPlatform = (apiPlatform: string) =>
    connected.filter((a) => a.platform.toUpperCase() === apiPlatform.toUpperCase());

  return { accounts, connected, loading, reload, byPlatform };
}
